/* 三國逗陣打 · 裝備的特殊效果（掛在模擬層 World 上，不碰 DOM）
 * 裝備資料（systems.js）裡的 fx 是被動、act 是主動。能套進武將被動框架（skillx.js 的 px）的就併進去：
 * 爆擊、追加傷害、反彈、回血、閃避、法抗、重生、光環；其餘（穿甲、背刺、彈射、連射、元素普攻、
 * 每 N 下落雷、格擋、怕火、反彈技能、技能護盾、控制減免、技能吸血、破甲、的盧、脫戰加速、赤兔）在這裡處理。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';

const W = SG.World.prototype;
const gd = SG.gd, dirTo = SG.dirTo, along = SG.along;
const { move, landing, mkStatus } = SG._sim;
const sign = (v) => (v > 0 ? 1 : v < 0 ? -1 : 0);
const freshPx = () => ({ evade: 0, crits: [], cleave: 0, bonus: [], reflect: 0, regen: 0, regenP: 0, auras: [], orb: 0, poison: null, lowHp: null, rebirth: 0, boom: null, manaKill: 0, resist: 0 });
const NUM = ['pen', 'backstab', 'minion', 'bounce', 'double', 'burnHit', 'block', 'fireTaken', 'spellReflect', 'ccRed', 'spellVamp', 'spellShred', 'mregen', 'ooc', 'minionDR', 'dilu', 'chitu',
  'antiCrit', 'pctHp', 'critChain', 'pierceN', 'spellblade', 'overShield', 'sigAmp', 'actCdr']; // v0.3.6 新招牌

// ---------- 重算：把裝備效果併進 px，其餘放 u.ifx ----------
const xRecalc0 = W.xRecalc;
W.xRecalc = function (u) {
  xRecalc0.call(this, u);
  if (u.kind !== 'hero') return;
  const items = (u.items || []).filter(Boolean).concat(u.seal && SG.ITEM.yuxi ? [SG.ITEM.yuxi] : []); // 傳國玉璽：持有就生效（不佔道具欄）
  u.ils = items.reduce((s, it) => s + (it.stats.ls || 0), 0) / 100;
  const list = items.filter((it) => it.fx);
  if (!list.length) { u.ifx = null; return; }
  const px = u.px || (u.px = freshPx()), f = { slowHit: null, elHit: null, nth: null, spellShield: null, burnAura: null, armorShred: null, ramp: null, execute: null, qimen: null, momentum: null, nilin: null, yuhuo: null };
  for (const k of NUM) f[k] = 0;
  // 虎符：兵器招牌（機率、數值）×1.3；先算好，下面合併時乘上
  const amp = 1 + list.reduce((s, it) => s + (it.fx.sigAmp || 0), 0);
  list.forEach((it, j) => {
    const e = it.fx;
    if (e.crit) px.crits.push(Object.assign({}, e.crit, { chance: e.crit.chance * amp, item: true }));
    if (e.bash) px.bonus.push(Object.assign({}, e.bash, { chance: e.bash.chance * amp, item: true }));
    if (e.lowHp) px.lowHp = e.lowHp; // 虎賁甲「背水」
    for (const k of ['armorShred', 'ramp', 'execute', 'qimen', 'momentum', 'nilin', 'yuhuo']) if (e[k]) f[k] = e[k];
    if (e.cleave) px.cleave = Math.max(px.cleave, e.cleave);
    if (e.reflect) px.reflect += e.reflect;
    if (e.regen) px.regen += e.regen;
    if (e.evade) px.evade = 1 - (1 - px.evade) * (1 - e.evade);
    if (e.resist) px.resist = 1 - (1 - px.resist) * (1 - e.resist / 100);
    if (e.rebirth) px.rebirth = px.rebirth ? Math.min(px.rebirth, e.rebirth) : e.rebirth;
    if (e.aura) px.auras.push(Object.assign({ key: 'item:' + u.id + ':' + it.id }, e.aura));
    for (const k of NUM) if (e[k]) f[k] = k === 'dilu' || k === 'chitu' ? e[k] : f[k] + e[k];
    if (e.slowHit) f.slowHit = e.slowHit;
    if (e.elHit) f.elHit = e.elHit;
    if (e.nth) f.nth = e.nth;
    if (e.spellShield) f.spellShield = e.spellShield;
    if (e.burnAura) f.burnAura = { r: Math.max(e.burnAura.r, f.burnAura ? f.burnAura.r : 0), dps: e.burnAura.dps + (f.burnAura ? f.burnAura.dps : 0) }; // 火甲（v0.3.0）
  });
  f.ccRed = Math.min(0.6, f.ccRed);
  // 虎符：其餘的兵器招牌（背刺、燃燒、冰緩、落雷、削甲、連發加速）也 ×1.3
  if (amp > 1) {
    f.backstab *= amp; f.burnHit *= amp;
    if (f.slowHit) f.slowHit = Object.assign({}, f.slowHit, { amt: Math.min(0.6, f.slowHit.amt * amp) });
    if (f.nth) f.nth = Object.assign({}, f.nth, { dmg: f.nth.dmg * amp });
    if (f.armorShred) f.armorShred = Object.assign({}, f.armorShred, { amt: f.armorShred.amt * amp });
    if (f.ramp) f.ramp = Object.assign({}, f.ramp, { as: f.ramp.as * amp });
  }
  u.ifx = f;
};

// ---------- 普攻：穿甲、背刺、打小兵加成（在爆擊計算時一起乘上去）----------
const xCrit0 = W.xCrit;
W.xCrit = function (u, dmg, a) {
  const t = a && a.target, f = u.ifx;
  // 鐵索連環：被鎖住的敵人，這一下兵器招牌（暴擊、重擊）必定觸發
  const sure = t && t.sureBy === u.id && this.t < (t.sureT || 0);
  const rand0 = SG.rand; if (sure) SG.rand = () => 0;
  let d = xCrit0.call(this, u, dmg, a);
  SG.rand = rand0;
  const crit = d > dmg * 1.01 && u.px && u.px.crits.length;
  const anti = t && t.ifx && t.ifx.antiCrit ? t.ifx.antiCrit : 0; // 連環鎖子甲：暴擊、背刺加成減半
  if (crit && anti) d = dmg + (d - dmg) * (1 - anti);
  if (crit && f) { this.sigFired(u); if (f.critChain && t) this.chainBolt(u, t, f.nth || { dmg: 140, jumps: 3, decay: 0.15, el: 'thunder' }); }
  if (!f || !t) return d;
  if (f.pen) { const ar = Math.max(0, this.xArmor(t)); d *= (100 + ar * 6) / (100 + Math.max(0, ar - f.pen) * 6); }
  if (f.backstab && !t.structure && t.f === sign(t.x - u.x)) { d *= 1 + f.backstab * (1 - anti); this.sigFired(u); if (u.human) this.dmgEvents.push({ x: t.x, y: t.y - 60, text: '背刺', team: t.team, src: u.id }); }
  if (f.minion && (t.kind === 'minion' || t.kind === 'creep' || t.summoned)) d *= 1 + f.minion;
  return d;
};

// ---------- 普攻命中：元素普攻、緩速、燃燒、每 N 下落雷、彈射、連射、方天畫戟橫掃 ----------
const xHit0 = W.xHit;
W.xHit = function (u, t) {
  const sure = t.sureBy === u.id && this.t < (t.sureT || 0), rand0 = SG.rand; // 鐵索：重擊也必定觸發
  if (sure) SG.rand = () => 0;
  const hp0 = t.hp;
  try { xHit0.call(this, u, t); } finally { SG.rand = rand0; }
  if (u.px && u.px.bonus.some((b) => b.item) && t.hp < hp0 && u.ifx) this.sigFired(u); // 重擊觸發（乘勢）
  const f = u.ifx;
  if (!f || !t.alive) return;
  if (f.elHit && this.mark) this.mark(t, f.elHit, u);
  if (f.slowHit && !t.structure) { t.st.slow = Math.max(t.st.slow, f.slowHit.dur); t.st.slowAmt = Math.max(t.st.slow > 0 ? t.st.slowAmt : 0, f.slowHit.amt); }
  if (f.burnHit && !t.structure) this.ignite(t, f.burnHit, 2, u);
  if (f.nth) {
    u.nthN = (u.nthN || 0) + 1;
    if (u.nthN >= f.nth.n) { u.nthN = 0; this.chainBolt(u, t, f.nth); this.sigFired(u); }
  }
  // 破甲錐「削甲」：每下護甲 -amt，疊到 max 層
  if (f.armorShred && !t.structure) { const s = f.armorShred; t.ashredN = this.t < (t.ashredT || 0) ? Math.min(s.max, (t.ashredN || 0) + 1) : 1; t.ashredAmt = s.amt; t.ashredT = this.t + s.dur; }
  // 諸葛連弩「連發加速」：連續打同一目標，每下攻速 +as%（最多 max 層）
  if (f.ramp) { u.rampN = u.rampTid === t.id ? Math.min(f.ramp.max, (u.rampN || 0) + 1) : 1; u.rampTid = t.id; u.rampAs = u.rampN * f.ramp.as; if (u.rampN === f.ramp.max) this.sigFired(u); }
  // 倚天劍「斬鐵」：打武將額外造成目標最大生命 pctHp 的物理傷害
  if (f.pctHp && t.kind === 'hero') this.damage(u, t, t.maxHp * f.pctHp, { quiet: true });
  // 太公兵法「兵法」：放完技能的下一下普攻附加等於法攻的法術傷害
  if (u.bladeReady && f.spellblade) { u.bladeReady = false; this.damage(u, t, u.matk || u.int || 0, { magic: true, spell: true }); this.fx({ k: 'spark', x: t.x, y: t.y - 30, col: '#e9c46a' }); }
  if (t.sureBy === u.id) t.sureBy = null; // 鐵索的「必定觸發」用掉了
  if (f.bounce && u.ranged) {
    // 彈到離目標最近的敵人（之前用 find 拿列表裡第一個，武將排在前面，常常跳過旁邊的小兵彈到遠處的武將）
    let o = null, best = SG.BOUNCE_R;
    for (const x of this.units) {
      if (x === t || !this.hostile(u, x) || x.structure || x.kind === 'seal' || !x.vis || x.vis[u.team] === false) continue;
      const d = gd(x.x, x.y, t.x, t.y);
      if (d < best) { best = d; o = x; }
    }
    if (o) { this.damage(u, o, u.atk * 0.8, { stagger: 0.1 }); this.fx({ k: 'spark', x: o.x, y: o.y - 20, col: '#e27a5a' }); }
  }
  if (f.double && u.ranged && SG.rand() < f.double) this.later(0.15, () => { if (t.alive && u.alive) { this.damage(u, t, u.atk, { stagger: 0.1 }); this.fx({ k: 'spark', x: t.x, y: t.y - 20, col: '#c9a24e' }); } });
};

SG.BOUNCE_R = 250; // 破軍弓／落日弓的彈射距離（v0.4.2.3：380 → 250）

// 連鎖雷（雷公錘、紫電）：先打目標，再跳向附近 jumps 名敵方單位，每跳傷害 -decay
W.chainBolt = function (u, t, n) {
  const e0 = this._el; this._el = n.el || 'thunder';
  const hit = new Set([t.id]); let cur = t, dmg = n.dmg;
  this.damage(u, t, dmg, { magic: true, spell: true }); this.fx({ k: 'thunder', x: t.x, y: t.y });
  for (let j = 0; j < (n.jumps || 0); j++) {
    const nx = this.units.filter((o) => this.hostile(u, o) && !o.structure && o.kind !== 'seal' && !hit.has(o.id) && gd(cur.x, cur.y, o.x, o.y) < 380).sort((p, q) => gd(cur.x, cur.y, p.x, p.y) - gd(cur.x, cur.y, q.x, q.y))[0];
    if (!nx) break;
    hit.add(nx.id); dmg *= 1 - (n.decay || 0); cur = nx;
    this.damage(u, nx, dmg, { magic: true, spell: true }); this.fx({ k: 'thunder', x: nx.x, y: nx.y });
  }
  this._el = e0;
};
// 兵器招牌觸發：戰鼓「乘勢」疊攻速
W.sigFired = function (u) {
  const m = u.ifx && u.ifx.momentum; if (!m) return;
  u.momN = this.t < (u.momT || 0) ? Math.min(m.max, (u.momN || 0) + 1) : 1; u.momT = this.t + m.t;
  this.addBuff(u, { id: 'momentum', t: m.t, as: m.as * u.momN });
};

// ---------- 受傷：格擋、怕火、小兵減傷、技能護盾（damage() 在扣護盾前呼叫）----------
W.itemTaken = function (src, t, a, o) {
  const f = t.ifx, sh = src.owner || src;
  t.combatT = this.t; if (sh.kind === 'hero') sh.combatT = this.t;
  if (!f) return a;
  if (f.block && o.basic && sign(sh.x - t.x) === t.f) a = Math.max(0, a - f.block);
  if (f.nilin && o.basic && sh.kind === 'hero' && sh.team !== t.team) this.addBuff(sh, { id: 'nilin', t: f.nilin.t, as: f.nilin.as, ms: f.nilin.ms, neg: true }); // 龍鱗寶鎧「逆鱗」
  if (f.fireTaken && (o.fire || o.pal === 'fire' || this.elNow && this.elNow(o) === 'fire')) a *= 1 + f.fireTaken;
  if (f.minionDR && (sh.kind === 'minion' || sh.kind === 'creep')) a *= 1 - f.minionDR;
  if (f.spellShield && !o.basic && sh.kind === 'hero' && !(t.sshCd > 0)) {
    const take = Math.min(a, f.spellShield.amt);
    a -= take; t.sshCd = f.spellShield.cd;
    this.fx({ k: 'spark', x: t.x, y: t.y - 40, col: '#cfe6ff' });
    if (t.human || sh.human) this.dmgEvents.push({ x: t.x, y: t.y - 70, text: '護心鏡', team: t.team, src: sh.id, tgt: t.id });
  }
  return a;
};

// ---------- 傷害之後：技能吸血、技能破甲、反彈技能 ----------
const xPost0 = W.xPost;
W.xPost = function (src, t, a, o) {
  xPost0.call(this, src, t, a, o);
  const sh = src.owner || src;
  if (a <= 0) return;
  // 普攻吸血（裝備的吸血屬性）
  if (o.basic && sh.ils > 0 && !t.structure) this.heal(sh, a * sh.ils);
  if (o.basic || o.reflected) return;
  const f = sh.ifx;
  if (f && sh.kind === 'hero' && t.kind !== 'ward') {
    if (f.spellVamp && !t.structure) {
      const v = a * f.spellVamp, over = Math.max(0, v - (sh.maxHp - sh.hp));
      this.heal(sh, v);
      if (f.overShield && over > 0) sh.st.shield = Math.min(f.overShield, (sh.st.shield || 0) + over); // 青囊秘卷「懸壺」：溢出轉護盾
    }
    if (f.spellShred && !t.structure) t.st.shred = Math.max(t.st.shred, f.spellShred);
  }
  const g = t.ifx;
  if (g && g.spellReflect && sh.kind === 'hero' && sh.alive && sh !== t) this.damage(t, sh, a * g.spellReflect, { magic: true, quiet: true, reflected: true, el: null });
};

// ---------- 控制減免 ----------
const applyCC0 = W.applyCC;
W.applyCC = function (src, t, cc) {
  const f = t && t.ifx;
  if (cc && f && f.ccRed) {
    const k = 1 - f.ccRed, c = Object.assign({}, cc);
    for (const key of ['stun', 'root', 'freeze', 'fear', 'silence', 'knockup', 'knockdown', 'taunt', 'charm', 'confuse', 'disarm']) if (c[key]) c[key] *= k;
    if (c.slow) c.slow = [c.slow[0], c.slow[1] * k];
    cc = c;
  }
  return applyCC0.call(this, src, t, cc);
};

// ---------- 的盧：瀕死躍出 ----------
const xPreKill0 = W.xPreKill;
W.xPreKill = function (src, t) {
  const f = t.ifx;
  if (t.kind === 'hero' && f && f.dilu && !(t.diluCd > 0) && t.alive !== false) {
    t.diluCd = f.dilu;
    const from = src && src.x != null ? src : { x: t.x - t.f, y: t.y };
    const d = dirTo(from, t.x, t.y), p = along(t.x, t.y, d[0] || d[1] ? d : [t.f, 0], 400), q = landing(t.x, t.y, p[0], p[1]);
    this.fx({ k: 'puff', x: t.x, y: t.y });
    t.x = q[0]; t.y = q[1]; t.hp = t.maxHp * 0.2; t.st.stun = 0; t.st.root = 0;
    this.fx({ k: 'puff', x: t.x, y: t.y });
    this.say(`${t.name} 的盧躍檀溪！`, 'info');
    return true;
  }
  return xPreKill0.call(this, src, t);
};

// ---------- 每步：回氣、脫戰加速、冷卻、赤兔衝撞、將令旗只給小兵 ----------
W.itemTick = function (dt) {
  for (const u of this.units) {
    if (u.kind !== 'hero' || !u.alive) continue;
    if (u.sshCd > 0) u.sshCd -= dt;
    if (u.qimenT > 0) u.qimenT -= dt;
    if (u.diluCd > 0) u.diluCd -= dt;
    if (u.chituCd > 0) u.chituCd -= dt;
    const f = u.ifx;
    if (!f) continue;
    if (f.mregen && u.maxMp && !SG.isNeng(u)) u.mp = Math.min(u.maxMp, u.mp + f.mregen * dt);
    // 火甲：每 0.5 秒燒一次周圍的敵方單位（火焰、法術傷害，吃法防）
    if (f.burnAura && (u.burnAuraT = (u.burnAuraT || 0) - dt) <= 0) {
      u.burnAuraT = 0.5;
      const low = f.yuhuo && u.hp / u.maxHp < f.yuhuo.below; // 朱雀焰鎧「浴火」：殘血時燒得更兇、回血
      if (low) u.hp = Math.min(u.maxHp, u.hp + u.maxHp * f.yuhuo.heal * 0.5);
      for (const t of this.enemiesNear(u, u.x, u.y, f.burnAura.r)) if (!t.structure) this.damage(u, t, f.burnAura.dps * 0.5 * (low ? 2 : 1), { magic: true, fire: true, quiet: true });
    }
    if (f.ooc && this.t - (u.combatT || -99) > 3) { u.st.msUp = Math.max(u.st.msUp, 0.3); u.st.msUpAmt = Math.max(u.st.msUp > 0 ? u.st.msUpAmt : 0, f.ooc); }
    if (f.chitu && !(u.chituCd > 0) && (u.loop === 'run' || u.loop === 'walk') && !u.act) {
      const t = this.units.find((o) => o.kind === 'hero' && this.hostile(u, o) && gd(o.x, o.y, u.x, u.y) < 50);
      if (t) { u.chituCd = f.chitu; this.damage(u, t, 60, { stagger: 0.3 }); this.applyCC(u, t, { knockup: 0.7 }); this.fx({ k: 'slam', x: t.x, y: t.y, col: '#c4302a' }); }
    }
  }
};
// 光環裡標了 minion 的只給己方小兵（將令旗）；其他照原本的光環邏輯（含攻速、移速）
const xAuras0 = W.xAuras;
W.xAuras = function (dt) {
  const due = (this._auraT || 0) - dt <= 0;
  xAuras0.call(this, dt);
  if (this.itemTick) this.itemTick(dt);
  if (!due) return;
  for (const u of this.units) {
    if (!u.alive || !u.px || !u.px.auras.length) continue;
    for (const a of u.px.auras) {
      if (!a.key || !a.key.startsWith('item:')) continue;
      if (a.minion) {
        this.units.forEach((t) => { if (t.alive && t.team === u.team && t.kind === 'minion' && gd(u.x, u.y, t.x, t.y) <= a.r) this.addBuff(t, { id: 'aura:' + a.key, t: 0.8, atkP: (a.atkP || 0) / 100, ms: a.ms || 0 }); });
      } else if (a.as || a.ms) {
        this.alliesNear(u, a.r).forEach((t) => this.addBuff(t, { id: 'aura2:' + a.key, t: 0.8, as: a.as || 0, ms: a.ms || 0 }));
      }
    }
  }
};
// 將令旗的光環不該讓武將也吃到攻擊加成：原本的光環迴圈會給所有友軍，這裡把它移除
const addBuff0 = W.addBuff;
W.addBuff = function (u, b) {
  if (b && b.id && b.id.startsWith('aura:item:') && u.kind === 'hero') {
    const key = b.id.slice(5), src = this.units.find((x) => x.px && x.px.auras.some((a) => a.key === key));
    const a = src && src.px.auras.find((x) => x.key === key);
    if (a && a.minion) return;
  }
  return addBuff0.call(this, u, b);
};

// ---------- 主動效果 ----------
const ACT = {
  heal(u, a) { this.alliesNear(u, a.r).concat([u]).forEach((t) => { if (t.alive) { this.heal(t, a.amt); this.fx({ k: 'heal', x: t.x, y: t.y, col: '#8fe08a' }); } }); },
  dispel(u) { const s = u.st; s.stun = s.root = s.slow = s.fear = s.silence = s.freeze = s.taunt = s.charm = s.confuse = s.disarm = s.shred = 0; s.burn = 0; u.dots = null; if (u.buffs) { u.buffs = u.buffs.filter((b) => !b.neg); this.addBuff(u, { id: 'dispel', t: 0.01 }); } this.fx({ k: 'heal', x: u.x, y: u.y, col: '#ffe95a' }); },
  charge(u, a) {
    const aim = u.input.aim, d = aim ? dirTo(u, aim[0], aim[1]) : [u.f, 0];
    const p = along(u.x, u.y, d, a.d), q = landing(u.x, u.y, p[0], p[1]);
    this.enemiesNear(u, (u.x + q[0]) / 2, (u.y + q[1]) / 2, a.d / 2 + 30).forEach((t) => { if (t.structure) return; this.damage(u, t, 80, { stagger: 0.4 }); this.applyCC(u, t, { knockback: 90 }); });
    this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; u.f = sign(d[0]) || u.f; this.fx({ k: 'slam', x: u.x, y: u.y, col: '#fffaf0' });
  },
  blink(u, a) { const aim = u.input.aim, d = aim ? dirTo(u, aim[0], aim[1]) : [u.f, 0], p = along(u.x, u.y, d, a.d), q = landing(u.x, u.y, p[0], p[1]); this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; if (Math.abs(d[0]) > 0.05) u.f = sign(d[0]); this.fx({ k: 'puff', x: u.x, y: u.y }); }, // 遁甲天書、奇門遁甲
  invis(u, a) { u.st.invis = Math.max(u.st.invis, a.t); this.fx({ k: 'puff', x: u.x, y: u.y }); },
  chain(u, a) {
    const hit = this.enemiesNear(u, u.x, u.y, a.r).filter((t) => !t.structure);
    hit.forEach((t) => { this.applyCC(u, t, { root: a.t }); t.sureBy = u.id; t.sureT = this.t + 4; this.fx({ k: 'spark', x: t.x, y: t.y - 20, col: '#9aa1a8' }); }); // 被鎖住：下一次兵器招牌必定觸發
    this.fx({ k: 'slam', x: u.x, y: u.y, col: '#9aa1a8' });
  },
  elixir(u) { this.heal(u, u.maxHp * 0.4); if (!SG.isNeng(u)) u.mp = Math.min(u.maxMp, u.mp + u.maxMp * 0.4); this.fx({ k: 'heal', x: u.x, y: u.y, col: '#ffd46b' }); },
  wine(u) { this.addBuff(u, { id: 'wine', t: 8, atkP: 0.2, taken: 0.1 }); this.fx({ k: 'spark', x: u.x, y: u.y - 30, col: '#ff9a4a' }); },
  bomb(u, a) {
    const aim = u.input.aim, d = aim ? dirTo(u, aim[0], aim[1]) : [u.f, 0], dist = aim ? Math.min(260, gd(u.x, u.y, aim[0], aim[1])) : 220;
    const p = along(u.x, u.y, d, dist), e0 = this._el; this._el = 'fire';
    this.later(0.35, () => {
      this.enemiesNear(u, p[0], p[1], 95).forEach((t) => { this.damage(u, t, a.dmg, { magic: true, stagger: 0.4 }); if (!t.structure) this.applyCC(u, t, { knockback: 70 }); });
      this.fx({ k: 'slam', x: p[0], y: p[1], col: '#ff9a4a' }); this.fx({ k: 'fire', x: p[0], y: p[1], pal: 'fire' });
    });
    this._el = e0;
  },
  smoke(u) { this.alliesNear(u, 170).concat([u]).forEach((t) => { if (t.alive && t.kind === 'hero') t.st.invis = Math.max(t.st.invis, 3); }); for (let i = 0; i < 3; i++) this.fx({ k: 'puff', x: u.x + (i - 1) * 50, y: u.y }); },
};
const useItem0 = W.useItem;
W.useItem = function (u, slot) {
  const it = u.items[slot], ready = it && !(u.icd[slot] > 0);
  if (!it || u.icd[slot] > 0 || !it.act || !ACT[it.act.k]) useItem0.call(this, u, slot);
  else { ACT[it.act.k].call(this, u, it.act); if (it.consumable) this.takeOne(u, slot); else u.icd[slot] = it.act.cd || 0; }
  if (!ready) return;
  const f = u.ifx;
  if (f && f.actCdr && u.icd[slot] > 0 && !it.consumable) u.icd[slot] *= 1 - f.actCdr; // 錦囊：典籍主動冷卻 -30%
  if (it.id === 'qimen' && f && f.qimen) { u.qimenT = f.qimen.t; u.qimenAmp = f.qimen.amp; } // 奇門遁甲：瞬移後技能傷害 +20%
};
// 被動有冷卻的主動裝備，給畫面層顯示用
SG.itemCd = (it) => (it.act && it.act.cd) || ({ dunjia: 14, qimen: 14, jueying: 20, xuantie: 30 })[it.id] || 0;
